<template>
    <div class="vant-field-date">
        <van-field :label="label" :value="text" :required="required" :placeholder="placeholder+label" @click="click"
                   :input-align="inputAlign" readonly :style="cellStyle"></van-field>
        <van-popup v-model="showPop" :label="label" position="bottom" :overlay="true">
            <van-datetime-picker v-bind="$attrs" :value="currentDate" :type="type" :title="'请选择' + label"
                                 @cancel="cancel" @confirm="confirm"></van-datetime-picker>
        </van-popup>
    </div>
</template>
<script>
    import {Field, Popup, DatetimePicker} from 'vant';
    import {ymdhmToType} from "../utils/vanDatetimePicker";
    import {format} from "../utils/date";
	import moment from "moment";

    export default {
        name: 'VanFieldDate',
        components: {
            [Field.name]: Field,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker
        },
        props: {
            value: {
                type: [String],
                default: undefined
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: '请选择'
            },
            format: {
                type: String,
                default: 'yyyy-MM-dd HH:mm'
            },
            inputAlign: {
                type: String,
                default: 'left'
            },
            onChange: {
                type: String,
                default: null
            },
            cellStyle: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                showPop: false
            }
        },
        methods: {
            confirm(value) {
                this.$emit('input', format(value, this.format));
                this.$emit('change', format(value, this.format));
                if (this.onChange) {
                    this.onChange();
                }
                this.showPop = false;
            },
            cancel() {
                this.showPop = false;
            },
            click() {
                if (!this.readonly) {
                    this.showPop = true;
                }
            }
        },
        computed: {
            text() {
                return this.value ? moment(this.value).format('YYYY-MM-DD HH:mm') : '';
            },
            currentDate() {
                return new Date();
            },
            type() {
                return ymdhmToType(this.format);
            }
        }
    }
</script>
<style>
    .vant-field-date>.van-cell>.van-cell__title {
        text-align: right;
        margin-right:1rem;
    }
    .vant-field-date>.van-cell--required::before {
        left: 107px;
        top: 13px;
    }
</style>